import { render, staticRenderFns } from "./Part-FormatItem.vue?vue&type=template&id=60537e62"
import script from "./Part-FormatItem.vue?vue&type=script&setup=true&lang=js"
export * from "./Part-FormatItem.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60537e62')) {
      api.createRecord('60537e62', component.options)
    } else {
      api.reload('60537e62', component.options)
    }
    module.hot.accept("./Part-FormatItem.vue?vue&type=template&id=60537e62", function () {
      api.rerender('60537e62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/tables/Part-FormatItem.vue"
export default component.exports